import Api from "../../axios"

export const getEmployeeFeedbackList=async(employeeId)=>{
    return await Api.get(`/employee_feedback_list?employee_id=${employeeId}`);
}